module.exports = __webpack_public_path__ + "img/MidSectionImage1.499ab16e.jpg";